import { useEffect } from "react";

const useInterval = (
  callback: Function,
  ms: number,
  condition?: boolean,
  deps?: React.DependencyList
) =>
  useEffect(() => {
    var interval: number;
    if (condition) {
      interval = setInterval(callback, ms);
    }
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [callback, condition, ms, ...(deps ?? [])]);

export default useInterval;
